import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import CompaniesService from 'api/services/CompaniesService';
import { RootState } from 'store/store';
import { TCompanyParams, TRole, TStatisticITem, TTeam } from 'store/types';

export const fetchCompanies = createAsyncThunk('fetchCompanies', async () => {
    const response = await CompaniesService.companies();
    return response.data;
});

export const fetchSingleCompany = createAsyncThunk('fetchSingleCompany', async (params: TCompanyParams) => {
    const response = await CompaniesService.company(params);
    return response.data;
});

// export const fetchTeams = createAsyncThunk('fetchTeams', async (params: TCompanyParams) => {
//     const response = await CompaniesService.teams(params);
//     return response.data;
// });

// export const fetchSingleTeam = createAsyncThunk('fetchSingleTeam', async (params: TCompanyParams) => {
//     const response = await CompaniesService.team(params);
//     return response.data;
// });

// export const fetchAgentStatistic = createAsyncThunk('fetchAgentStatistic', async (params: TCompanyParams) => {
//     const response = await CompaniesService.summary(params);
//     return response.data;
// });

type TCompaniesState = {
    companies: {
        data: Array<{
            id: string;
            name: string;
            roles: Array<{
                id: string;
                name: string;
                type: string;
            }>;
            teams: Array<{
                id: string;
                title: string;
            }>;
        } | null>;
        isLoading: boolean;
    };
    company: {
        data:
            | {}
            | {
                  id: string;
                  name: string;
                  roles: Array<TRole>;
                  teams: Array<{
                      id: string;
                      title: string;
                  }>;
              };
        isLoading: boolean;
    };
};

const initialState: TCompaniesState = {
    companies: {
        data: [],
        isLoading: false,
    },
    company: {
        data: {},
        isLoading: false,
    },
};

export const companiesSlice = createSlice({
    name: 'companies',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchCompanies.pending, state => {
                state.companies.isLoading = true;
            })
            .addCase(fetchCompanies.fulfilled, (state, action) => {
                state.companies.data = action.payload;
                state.companies.isLoading = false;
            });
        builder
            .addCase(fetchSingleCompany.pending, state => {
                state.company.isLoading = true;
            })
            .addCase(fetchSingleCompany.fulfilled, (state, action) => {
                state.company.data = action.payload;
                state.company.isLoading = false;
            });
        // builder
        //     .addCase(fetchTeams.pending, state => {
        //         state.teams.isLoading = true;
        //     })
        //     .addCase(fetchTeams.fulfilled, (state, action) => {
        //         state.teams.data = action.payload;
        //         state.teams.isLoading = false;
        //     });
        // builder
        //     .addCase(fetchSingleTeam.pending, state => {
        //         state.team.isLoading = true;
        //     })
        //     .addCase(fetchSingleTeam.fulfilled, (state, action) => {
        //         state.team.data = action.payload;
        //         state.team.isLoading = false;
        //     });
        // builder
        //     .addCase(fetchAgentStatistic.pending, state => {
        //         state.agentStatistic.isLoading = true;
        //     })
        //     .addCase(fetchAgentStatistic.fulfilled, (state, action) => {
        //         state.agentStatistic.data = action.payload;
        //         state.agentStatistic.isLoading = false;
        //     });
        // builder
        //     .addCase(fetchAgentStatisticByTimeframe.pending, state => {
        //         state.agentStatisticByTimeframe.isLoading = true;
        //     })
        //     .addCase(fetchAgentStatisticByTimeframe.fulfilled, (state, action) => {
        //         state.agentStatisticByTimeframe.data = action.payload;
        //         state.agentStatisticByTimeframe.isLoading = false;
        //     });
    },
});

export const selectCompanies = createSelector(
    [(state: RootState) => state.companiesState.companies],
    data => data.data,
);
export const selectCompaniesIsLoading = createSelector(
    [(state: RootState) => state.companiesState.companies],
    data => data.isLoading,
);

export default companiesSlice.reducer;
